import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoOrdiniAFornitoreStep2Component
} from './conservazione-carica-documento-ordini-a-fornitore-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('home.conservazione-carica-documento-ordini-a-fornitore-step2', {
      url: '/conservazione-carica-documento-ordini-a-fornitore',
      ncyBreadcrumb: {
        label: 'Carica Ordini a Fornitore',
        parent: 'home.conservazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione Carica Documento'
      },
      'views': {
        'homeContent': {
          template: '<conservazione-carica-documento-ordini-a-fornitore-step2 flex="100"></conservazione-carica-documento-ordini-a-fornitore-step2>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoOrdiniAFornitoreStep2Module: string = ng
  .module('conservazione-carica-documento-ordini-a-fornitore-step2', [
    'ui.bootstrap',
    uiRouter,
  ])
  .component('conservazioneCaricaDocumentoOrdiniAFornitoreStep2', ConservazioneCaricaDocumentoOrdiniAFornitoreStep2Component)
  .config(stateConfig)
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-ordini-a-fornitore-step2/conservazione-carica-documento-ordini-a-fornitore-step2.module.ts